import Layout from 'src/components/Layout';
import Navbar from 'src/components/NavBar';
import useCompany from 'src/hooks/useCompany';
import InvoiceScanManagerContextProvider from 'src/sections/invoice_scan_manager/InvoiceScanManagerContext';
import InvoiceScanManagerHeader from 'src/sections/invoice_scan_manager/InvoiceScanManagerHeader';
import InvoiceScanManagerSplitter from 'src/sections/invoice_scan_manager/InvoiceScanManagerSplitter';
import ReviewDocumentPanel from 'src/sections/invoice_scan_manager/ocr/ReviewDocumentPanel';

const InvoiceScanManager = () => {
  const { company: selectedCompany } = useCompany();

  return (
    <InvoiceScanManagerContextProvider>
      <Navbar title="Scan Manager" />
      <Layout>
        <InvoiceScanManagerHeader />
        <ReviewDocumentPanel />
        {selectedCompany && selectedCompany.companyId ? (
          <InvoiceScanManagerSplitter />
        ) : (
          <div className="text-center text-sm font-bold mt-2">Please Select a Company First</div>
        )}
      </Layout>
    </InvoiceScanManagerContextProvider>
  );
};

export default InvoiceScanManager;
